import { EventEmitter } from "../main";

// Подписки на глобальную шину переживают компонент: без $off каждый
// размонтированный инстанс остаётся в памяти и продолжает обрабатывать события.
// busOn запоминает подписку и снимает её в beforeDestroy.
export default {
  created() {
    this._busListeners = [];
  },
  methods: {
    busOn(event, handler, bus = EventEmitter) {
      bus.$on(event, handler);
      this._busListeners.push({ bus, event, handler });
    },
  },
  beforeDestroy() {
    this._busListeners.forEach(({ bus, event, handler }) =>
      bus.$off(event, handler)
    );
    this._busListeners = [];
  },
};
